import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

// component
import { StyledText } from "../common";
import pulseLogo from "../images/pulseLogo.png";

const MotivationalCard = ({ item, previousItem, nextItem }) => {
  const { imageurl, title, message } = item;

  const { imageurl: peviousImage } = previousItem;
  const { imageurl: nextImage } = nextItem;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        padding: 0,
        margin: 0,
        height: "380px",
      }}
    >
      <div
        style={{
          backgroundImage: `url(${peviousImage})`,
          backgroundPosition: "right",
          backgroundSize: "cover",
          width: "10%",
          borderTopRightRadius: 15,
          borderBottomRightRadius: 15,
          marginRight: 10,
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "space-between",
          alignContent: "space-between",
          backgroundImage: `url(${imageurl})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          width: "80%",
          flex: 1,
          borderRadius: 15,
          padding: 10,
        }}
      >
        {message && (
          <StyledText size={28} color='#FFCC00'>
            {message}
          </StyledText>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={pulseLogo}
            alt='pulse logo'
            style={{ objectFit: "contain", width: "100px" }}
          />
          <StyledText color='white'> | Motivation</StyledText>
        </div>
      </div>
      <div
        style={{
          backgroundImage: `url(${nextImage})`,
          backgroundPosition: "left",
          backgroundSize: "cover",
          width: "10%",
          borderTopLeftRadius: 15,
          borderBottomLeftRadius: 15,
          marginLeft: 10,
        }}
      />
    </div>
  );
};

export default MotivationalCard;
